import { render, staticRenderFns } from "./docente-ingreso.vue?vue&type=template&id=21332730"
import script from "./docente-ingreso.vue?vue&type=script&lang=js"
export * from "./docente-ingreso.vue?vue&type=script&lang=js"
import style0 from "./docente-ingreso.vue?vue&type=style&index=0&id=21332730&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports